import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, TextField, Typography } from '@material-ui/core';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteEvent } from '../../hooks/event/useSiteEvent';
import { useSiteContext } from '../../SiteContext';
import SiteEventConfigurator from '../events/SiteEventConfigurator';
import { SlotRenderer } from '../renderers/SlotRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
const StyledDialog = styled(Dialog) `
  /* z-index: 10000 !important; */
`;
export const SiteDialog = props => {
    var _a, _b, _c, _d;
    const { data, children } = props;
    const { editing, isHover, hoverProps, setHoverComponent } = useSiteContext();
    const component = useSubscribeComponentChanges(SiteDialogPlugin, props);
    const { emit } = useSiteEvent(component);
    const isHovering = useMemo(() => {
        return isHover(component);
    }, [component, isHover]);
    // console.log('site dialog render', data);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteDialogPlugin }, props),
        React.createElement(StyledDialog, { open: true, className: 'site-dialog', fullScreen: (_a = component.props) === null || _a === void 0 ? void 0 : _a.fullScreen, fullWidth: (_b = component.props) === null || _b === void 0 ? void 0 : _b.fullWidth, maxWidth: (_c = component.props) === null || _c === void 0 ? void 0 : _c.maxWidth, PaperProps: Object.assign({ onMouseOver: () => editing && !isHovering && setHoverComponent(component), onMouseOut: () => editing && isHovering && setHoverComponent(undefined) }, hoverProps(component)), onClose: () => !editing && emit('onDialogClose') },
            React.createElement(DialogTitle, null, ((_d = component.props) === null || _d === void 0 ? void 0 : _d.title) || ''),
            React.createElement(DialogContent, null,
                React.createElement(SlotRenderer, { component: component, slot: 'dialog-content' })),
            React.createElement(DialogActions, null,
                React.createElement(SlotRenderer, { component: component, slot: 'dialog-buttons' }))),
        children));
};
export const SiteDialogConfigurator = props => {
    var _a, _b, _c, _d, _e, _f;
    const { component, update, updateSlot, remove } = useConfigComponent(props.component);
    const actionsComponent = useMemo(() => {
        var _a;
        return (_a = component.children) === null || _a === void 0 ? void 0 : _a.find((child) => child.slot === 'actions');
    }, [component]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', label: 'Name', value: component.name || '', InputProps: { disableUnderline: true }, onChange: event => update('name', event.target.value) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, size: 'small', label: 'Title', value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.title) || '', InputProps: { disableUnderline: true }, onChange: event => update('props.title', event.target.value) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Full Screen', control: React.createElement(Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!((_b = component.props) === null || _b === void 0 ? void 0 : _b.fullScreen), onChange: () => {
                        var _a;
                        update('props.fullScreen', !((_a = component.props) === null || _a === void 0 ? void 0 : _a.fullScreen));
                    } }) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Full Width', control: React.createElement(Checkbox, { size: 'small', color: 'primary', className: 'checkbox', checked: !!((_c = component.props) === null || _c === void 0 ? void 0 : _c.fullWidth), onChange: () => {
                        var _a;
                        update('props.fullWidth', !((_a = component.props) === null || _a === void 0 ? void 0 : _a.fullWidth));
                    } }) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, size: 'small', label: 'Max Width', value: (_e = (_d = component.props) === null || _d === void 0 ? void 0 : _d.maxWidth) !== null && _e !== void 0 ? _e : '', InputProps: { disableUnderline: true }, onChange: event => {
                    const { value } = event.target;
                    if (value === '' || typeof value === 'undefined') {
                        remove('props.maxWidth');
                    }
                    else {
                        update('props.maxWidth', !value || value === 'false' ? false : value);
                    }
                } },
                React.createElement(MenuItem, { value: '', selected: typeof ((_f = component.props) === null || _f === void 0 ? void 0 : _f.maxWidth) === 'undefined' }, "Default"),
                ['xs', 'sm', 'md', 'lg', 'xl', false].map((value) => {
                    var _a;
                    return (React.createElement(MenuItem, { key: `${value}`, value: `${value}`, selected: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.maxWidth) === value }, !value ? 'Disabled' : value));
                }))),
        React.createElement(Box, { mt: 1 },
            React.createElement(Typography, { variant: 'overline' }, "Events")),
        React.createElement(SiteEventConfigurator, { component: component, eventTypes: ['onDialogClose'] })));
};
export const SiteDialogPlugin = {
    name: 'Site Dialog',
    type: 'dialog',
    categories: ['dialog'],
    component: SiteDialog,
    configurator: SiteDialogConfigurator,
    slots: [
        {
            name: 'Dialog Content',
            type: 'component-stack',
            slot: 'dialog-content'
        },
        {
            name: 'Dialog Buttons',
            type: 'component-stack',
            slot: 'dialog-buttons'
        }
    ]
};
//# sourceMappingURL=SiteDialogPlugin.js.map